var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrepaidRecharge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_65",
    "data-name": "Group 65",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.493,
    height: 36.332,
    viewBox: "0 0 33.493 36.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_355",
    "data-name": "Path 355",
    transform: "translate(0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.03041839599609 35.5815544128418 L 4.541448593139648 35.5815544128418 C 2.450838804244995 35.5815544128418 0.7499987483024597 33.88071441650391 0.7499987483024597 31.79010581970215 L 0.7499987483024597 4.541445255279541 C 0.7499987483024597 2.450835227966309 2.450838804244995 0.750005304813385 4.541448593139648 0.750005304813385 L 17.03041839599609 0.750005304813385 C 19.12102890014648 0.750005304813385 20.82185935974121 2.450835227966309 20.82185935974121 4.541445255279541 L 20.82185935974121 31.79010581970215 C 20.82185935974121 33.88071441650391 19.12102890014648 35.5815544128418 17.03041839599609 35.5815544128418 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.541439056396484 1.499996185302734 C 2.864377975463867 1.499996185302734 1.499998092651367 2.864383697509766 1.499998092651367 4.541444778442383 L 1.499998092651367 31.79010581970215 C 1.499998092651367 33.46716690063477 2.864377975463867 34.83154678344727 4.541439056396484 34.83154678344727 L 17.03041839599609 34.83154678344727 C 18.70747947692871 34.83154678344727 20.07185935974121 33.46716690063477 20.07185935974121 31.79010581970215 L 20.07185935974121 4.541444778442383 C 20.07185935974121 2.864383697509766 18.70747947692871 1.499996185302734 17.03041839599609 1.499996185302734 L 4.541439056396484 1.499996185302734 M 4.541439056396484 -3.814697265625e-06 L 17.03041839599609 -3.814697265625e-06 C 19.53857803344727 -3.814697265625e-06 21.57185935974121 2.033275604248047 21.57185935974121 4.541444778442383 L 21.57185935974121 31.79010581970215 C 21.57185935974121 34.29827499389648 19.53857803344727 36.33154678344727 17.03041839599609 36.33154678344727 L 4.541439056396484 36.33154678344727 C 2.033267974853516 36.33154678344727 -1.9073486328125e-06 34.29827499389648 -1.9073486328125e-06 31.79010581970215 L -1.9073486328125e-06 4.541444778442383 C -1.9073486328125e-06 2.033275604248047 2.033267974853516 -3.814697265625e-06 4.541439056396484 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#002970"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M-645.111,1363.923h5.367",
    transform: "translate(653.626 -1359.469)",
    fill: "#c49d00",
    stroke: "#00baf2",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M-645.111,1363.923h8.944",
    transform: "translate(651.355 -1332.22)",
    fill: "#fff3f4",
    stroke: "#00baf2",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(9.65 10.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,12.162V0H23.843V12.162H2.825L0,15.942Z",
    transform: "translate(0 0)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_965_",
    "data-name": "965****",
    transform: "translate(8.135 6.838)",
    fill: "#fff",
    fontSize: 4,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "965****")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaidRecharge);
export default __webpack_public_path__ + "static/media/prepaid_recharge.a0674b661d0c7ffba47ae8a2cfd1e96f.svg";
export { ForwardRef as ReactComponent };